/* EXODIA PARTS — thème Shopify, script du site (Version 11, d'après la Version 9).
   Le site autour du configurateur : bandeau, en-tête (liens, menu « MENU » sur téléphone), révélations « laser »,
   catalogue en rail, nuanciers, marques, FAQ, interrupteur (réglage, désactivé par défaut), compteur « PANIER (n) ».
   V11 : plus de rideau d'entrée — la page d'accueil s'ouvre directement ; « ouvrir » et « estOuvert » restent dans
   l'API pour les scripts qui les appellent (le configurateur) et répondent « déjà ouvert ».
   Le configurateur 3D, la fiche produit et le panier ont leurs propres scripts (exodia-configurateur.js, exodia-cart.js).

   window.EXODIA_THEME (créé dans layout/theme.liquid, complété ici) :
     formatMoney(cents) · toast(texte) · annoncer(texte) · aller(id) · ouvrir({instant}) · estOuvert()
     majPanier(cartJson) · rafraichirPanier() · rafraichir()
   Événements : document reçoit « exodia:ouvert » (detail { instant: true }) une fois au chargement, après les autres
   scripts différés ; il écoute « exodia:panier » (detail = /cart.js) et « exodia:etat » (detail = état du
   configurateur : marque, rimHex, gravure). Conventions : [data-aller="id"] fait défiler jusqu'à une section ;
   [data-configurer='{json}'] appelle EXODIA_SITE.configurer(preset) quand le configurateur est sur la page, sinon
   suit le lien (adresse du configurateur avec les paramètres). Voir INTERFACES.md. */
(function () {
  'use strict';
  var T = window.EXODIA_THEME = window.EXODIA_THEME || {};
  var root = document.documentElement;
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function normal(s) { s = String(s || ''); try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) {} return s.toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function str(k, d) { return (T.strings && T.strings[k]) || d || ''; }
  var mqReduit = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  function reduit() { return !!mqReduit.matches; }
  var mqDesk = window.matchMedia ? matchMedia('(min-width: 1024px)') : { matches: true };
  var mqFin = window.matchMedia ? matchMedia('(hover: hover) and (pointer: fine)') : { matches: true };
  function emettre(nom, detail) { try { document.dispatchEvent(new CustomEvent(nom, { detail: detail })); } catch (e) {} }

  /* ================================================================ money (shop.money_format) */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10); if (isNaN(cents)) cents = 0;
    format = format || T.moneyFormat || '{{amount_with_comma_separator}} €';
    function fmt(n, dec, mil, sepDec) {
      var s = (n / 100).toFixed(dec), p = s.split('.');
      return p[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + mil) + (p[1] ? sepDec + p[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount': return fmt(cents, 2, ',', '.');
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        // same separators as Shopify's money filter (1.134,65 · 1 134,65 · 1 134.65 · 1'134.65)
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fmt(cents, 0, ' ', ',');
        case 'amount_with_period_and_space_separator': return fmt(cents, 2, ' ', '.');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, '\'', '.');
        default: return fmt(cents, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }

  /* ================================================================ toast, live region */
  var toast = $('#toast'), toastMin = null, annonceEl = $('#annonce');
  function montrerToast(t) {
    if (!toast) return;
    toast.textContent = t; toast.classList.add('on');
    clearTimeout(toastMin); toastMin = setTimeout(function () { toast.classList.remove('on'); toast.textContent = ''; }, 2600);
  }
  function annoncer(t) { if (!annonceEl) return; annonceEl.textContent = ''; setTimeout(function () { annonceEl.textContent = t; }, 30); }

  /* ================================================================ « BON (n) » = cart.item_count */
  function majPanier(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    var n = cart.item_count;
    $$('[data-cart-count]').forEach(function (el) { if (el.textContent !== String(n)) el.textContent = String(n); });
    $$('[data-cart-link]').forEach(function (b) {
      b.classList.toggle('plein', n > 0);
      var a = n === 0 ? str('panier_aria_zero', 'Panier : vide') : n === 1 ? str('panier_aria_un', 'Panier : 1 article')
        : str('panier_aria_n', 'Panier : {n} articles').replace(/__N__|\{n\}|\{\{\s*count\s*\}\}/, n);
      b.setAttribute('aria-label', a);
    });
  }
  function rafraichirPanier() {
    var url = (T.routes && T.routes.cart_js) || '/cart.js';
    if (!window.fetch) return Promise.resolve(null);
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) majPanier(c); return c; })
      .catch(function () { return null; });
  }
  document.addEventListener('exodia:panier', function (e) { if (e.detail) majPanier(e.detail); else rafraichirPanier(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) rafraichirPanier(); });

  /* ================================================================ laser (D5) */
  function laser(el, dur) {
    if (!el) return;
    var inner = $('.lz-in', el) || el;
    if (reduit() || !inner.animate) { if (inner.animate) inner.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 150 }); el.classList.remove('lz-attente'); return; }
    var ligne = $('.lz-ligne', el);
    if (!ligne) { ligne = document.createElement('span'); ligne.className = 'lz-ligne'; ligne.setAttribute('aria-hidden', 'true'); el.appendChild(ligne); }
    var largeur = inner.offsetWidth || el.offsetWidth;
    var debut = inner.offsetLeft;
    el.classList.remove('lz-attente');
    inner.animate([{ clipPath: 'inset(0 100% 0 0)', opacity: .35 }, { clipPath: 'inset(0 0% 0 0)', opacity: 1 }], { duration: dur, easing: 'cubic-bezier(.2,0,0,1)' });
    ligne.animate([
      { transform: 'translateX(' + debut + 'px)', opacity: 1 },
      { transform: 'translateX(' + (debut + largeur) + 'px)', opacity: 1, offset: .92 },
      { transform: 'translateX(' + (debut + largeur) + 'px)', opacity: 0 }
    ], { duration: dur, easing: 'cubic-bezier(.2,0,0,1)' });
  }
  var ioTitre = null;
  function preparerLasers(dans) {
    $$('[data-laser]', dans).forEach(function (h) {
      if (h.hasAttribute('data-laser-pret')) return;
      h.setAttribute('data-laser-pret', '');
      var inner = document.createElement('span'); inner.className = 'lz-in';
      while (h.firstChild) inner.appendChild(h.firstChild);
      h.appendChild(inner); h.classList.add('lz');
      if (!h.hasAttribute('tabindex')) h.setAttribute('tabindex', '-1');
      if (window.IntersectionObserver && !reduit()) {
        if (!ioTitre) ioTitre = new IntersectionObserver(function (ents) {
          ents.forEach(function (en) { if (en.isIntersecting) { ioTitre.unobserve(en.target); laser(en.target, 600); } });
        }, { threshold: .4 });
        h.classList.add('lz-attente'); ioTitre.observe(h);
      }
    });
  }

  /* ================================================================ section numbers (decorative) */
  function numeroterFantomes() {
    $$('main .fantome').forEach(function (f, i) { f.textContent = ('0' + (i + 1)).slice(-2); });
  }

  /* ================================================================ no shutter (V11): the page is open from the start */
  var ouvert = true;
  root.classList.add('ouvert');
  function estOuvert() { return ouvert; }
  // kept for the scripts that still call it (the configurator): nothing to open any more
  function ouvrir() { if (!root.classList.contains('ouvert')) root.classList.add('ouvert'); }

  /* ================================================================ navigation: scrolling, menu */
  function focusDe(id) {
    if (id === 'scene') return $('#etabli-titre') && mqDesk.matches ? $('#etabli-titre') : ($('#bloc-nom') || $('#config-t'));
    if (id === 'sortie') return $('#sortie-t');
    if (id === 'entree') return $('#accueil-titre');
    var el = document.getElementById(id); if (!el) return null;
    var lb = el.getAttribute('aria-labelledby');
    var h = document.getElementById(id + '-t') || (lb && document.getElementById(lb)) || $('h2, h3', el);
    if (h && !h.hasAttribute('tabindex')) h.setAttribute('tabindex', '-1');
    return h;
  }
  function defilerFenetre(y) {
    var y0 = window.pageYOffset;
    try { window.scrollTo({ top: y, behavior: reduit() ? 'auto' : 'smooth' }); } catch (e) { window.scrollTo(0, y); }
    if (!reduit()) setTimeout(function () { if (Math.abs(window.pageYOffset - y0) < 2 && Math.abs(y - y0) >= 2) window.scrollTo(0, y); }, 500);
  }
  function aller(id, focusCible) {
    var el = id ? document.getElementById(id) : null; if (!el) return false;
    var y = id === 'entree' ? 0 : el.getBoundingClientRect().top + window.pageYOffset;
    // the configurator's stage: on phones stop above the sticky header so the « LA PAIRE | AVANT | ARRIÈRE » tabs show
    if (id === 'scene' && !matchMedia('(min-width: 1024px)').matches) { var hh = $('#ascenseur'); y = Math.max(0, y - (hh ? hh.offsetHeight : 48) - 8); }
    defilerFenetre(y);
    setTimeout(function () {
      var f = typeof focusCible === 'function' ? focusCible() : (focusCible || focusDe(id));
      if (f) { try { f.focus({ preventScroll: true }); } catch (e) {} }
    }, 60);
    return true;
  }
  function configurerVia(preset) {
    var S = window.EXODIA_SITE;
    if (S && typeof S.configurer === 'function') {
      try { S.configurer(preset); return true; } catch (e) { return false; }
    }
    return false;
  }

  var ascBtn = $('#asc-btn'), ascListe = $('#asc-liste');
  function liensMenu() { return ascListe ? $$('a, button', ascListe).filter(function (a) { return a.offsetParent !== null; }) : []; }
  function fermerListe(rendreFocus) {
    if (!ascListe || ascListe.hidden) return;
    ascListe.hidden = true; ascBtn.setAttribute('aria-expanded', 'false'); var p = $('#asc-plus'); if (p) p.textContent = '+';
    var m = $('main'); if (m) m.inert = false;
    if (rendreFocus) ascBtn.focus();
  }
  // [data-aller="id"] scrolls to a section on this page, else follows the link · [data-configurer] → the configurator
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest('[data-configurer], [data-aller]'); if (!a) return;
    var pr = a.getAttribute('data-configurer');
    if (pr !== null) {
      var o = {}; try { o = JSON.parse(pr || '{}') || {}; } catch (er) { o = {}; }
      if (configurerVia(o)) { e.preventDefault(); fermerListe(); return; }
      // no configurator on this page: follow the link; its URL parameters carry the preset (else this copy does)
      if ((a.getAttribute('href') || '').indexOf('?') < 0) { try { sessionStorage.setItem('exodia-preset', JSON.stringify(o)); } catch (er) {} }
      return;
    }
    var id = a.getAttribute('data-aller');
    if (document.getElementById(id)) { e.preventDefault(); fermerListe(); aller(id); }
    // else: follow the href (the home page with #id)
  });
  // the sort select of the shop page (/collections): goes to /collections/all?sort_by=…
  document.addEventListener('change', function (e) {
    var s = e.target.closest('select[data-tri-url]'); if (!s) return;
    location.href = s.getAttribute('data-tri-url') + '?sort_by=' + encodeURIComponent(s.value);
  });
  // plain links to an anchor of this page (menus entered in Shopify, e.g. « /#faq »)
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest('a[href*="#"]'); if (!a || a.hasAttribute('data-aller') || a.hasAttribute('data-configurer') || a.hasAttribute('data-question')) return;
    var u; try { u = new URL(a.href, location.href); } catch (er) { return; }
    if (u.origin !== location.origin || u.pathname !== location.pathname || u.search !== location.search || !u.hash) return;
    var id = decodeURIComponent(u.hash.slice(1));
    if (!/^[A-Za-z][\w-]*$/.test(id) || !document.getElementById(id)) return;
    e.preventDefault(); fermerListe(); aller(id);
    try { history.replaceState(null, '', '#' + id); } catch (er) {}
  });

  if (ascBtn && ascListe) {
    // the shop links are written once, in the nav; the menu repeats them (it is the only menu below 1024 px)
    var boutique = $('#asc-boutique');
    if (boutique) {
      $$('#asc-nav a').forEach(function (a) {
        var li = document.createElement('li'), c = a.cloneNode(true);
        c.removeAttribute('class'); li.appendChild(c); boutique.appendChild(li);
      });
    }
    var ouvrirListe = function () {
      try { ascListe.style.setProperty('--menu-top', Math.max(0, Math.round($('#ascenseur').getBoundingClientRect().bottom)) + 'px'); } catch (e) {}
      ascListe.hidden = false; ascBtn.setAttribute('aria-expanded', 'true'); var p = $('#asc-plus'); if (p) p.textContent = '−';
      var c = $('a[aria-current="page"]', ascListe) || liensMenu()[0]; if (c) c.focus();
      var m = $('main'); if (!mqDesk.matches && m) m.inert = true;
    };
    ascBtn.addEventListener('click', function () { if (ascListe.hidden) ouvrirListe(); else fermerListe(); });
    ascListe.addEventListener('keydown', function (e) {
      var liens = liensMenu(), i = liens.indexOf(document.activeElement);
      if (e.key === 'Escape') { fermerListe(true); return; }
      if (!liens.length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); liens[(i + 1) % liens.length].focus(); }
      if (e.key === 'ArrowUp') { e.preventDefault(); liens[(i - 1 + liens.length) % liens.length].focus(); }
      if (e.key === 'Home') { e.preventDefault(); liens[0].focus(); }
      if (e.key === 'End') { e.preventDefault(); liens[liens.length - 1].focus(); }
    });
    ascListe.addEventListener('focusout', function (e) {
      var vers = e.relatedTarget;
      if (vers && !ascListe.contains(vers) && vers !== ascBtn) fermerListe();
    });
    $('#ascenseur').addEventListener('keydown', function (e) { if (e.key === 'Escape' && !ascListe.hidden) fermerListe(true); });
    document.addEventListener('click', function (e) { if (!ascListe.hidden && !e.target.closest('.asc-centre')) fermerListe(); });
    // the menu is only for small screens: close it when the window grows past the links
    if (mqDesk.addEventListener) mqDesk.addEventListener('change', function (ev) { if (ev.matches) fermerListe(); });
  }

  /* ================================================================ announcement bar, top height */
  (function () {
    var bar = $('#annonce-bar'), b = $('#annonce-pause'); if (!bar || !b) return;
    b.addEventListener('click', function () {
      var on = b.getAttribute('aria-pressed') !== 'true';
      b.setAttribute('aria-pressed', String(on));
      b.setAttribute('aria-label', on ? str('bandeau_relancer', 'Relancer le bandeau') : str('bandeau_pause', 'Mettre le bandeau en pause'));
      bar.classList.toggle('pause', on);
    });
  })();
  function majHaut() {
    var a = $('#annonce-bar'), h = $('#ascenseur');
    root.style.setProperty('--haut', ((a ? a.offsetHeight : 0) + (h ? h.offsetHeight : 48)) + 'px');
  }
  majHaut();
  window.addEventListener('resize', majHaut);
  try { document.fonts.ready.then(majHaut); } catch (e) {}

  /* ================================================================ hairline plans (decorative SVG) */
  function f1(v) { return v.toFixed(1); }
  function pol(r, deg) { var a = deg * Math.PI / 180; return f1(Math.cos(a) * r) + ' ' + f1(Math.sin(a) * r); }
  var planN = 0;
  function planAxes() { return '<svg class="plan plan-axes" viewBox="-230 -230 460 460" aria-hidden="true" focusable="false"><path class="plan-axe" d="M-228 0H228M0 -228V228"/></svg>'; }
  function plan(o) {
    o = o || {};
    var id = 'plan-logo-' + (++planN), i, s = '', r = function (v) { return v.toFixed(1); };
    s += '<svg class="plan" viewBox="-230 -230 460 460" aria-hidden="true" focusable="false"><g>';
    [210, 202, 190, 180].forEach(function (rr, k) { s += '<circle r="' + rr + '"' + (k === 2 ? ' class="plan-fin"' : '') + '/>'; });
    for (i = 0; i < 36; i++) {
      var ah = i * 10 * Math.PI / 180, ar = ah + (i % 2 ? 1 : -1) * 26 * Math.PI / 180;
      var x1 = Math.cos(ah) * 30, y1 = Math.sin(ah) * 30, x2 = Math.cos(ar) * 180, y2 = Math.sin(ar) * 180;
      var dx = x2 - x1, dy = y2 - y1, L = Math.sqrt(dx * dx + dy * dy);
      s += '<line class="plan-rayon" x1="' + r(x1) + '" y1="' + r(y1) + '" x2="' + r(x2) + '" y2="' + r(y2) + '"/>';
      s += '<line class="plan-tete" x1="' + r(x2 - dx / L * 12) + '" y1="' + r(y2 - dy / L * 12) + '" x2="' + r(x2) + '" y2="' + r(y2) + '"/>';
    }
    if (o.disque) {
      s += '<circle r="152"/><circle r="116"/><circle class="plan-trous" r="134"/>';
      for (i = 0; i < 6; i++) { var a = i * 60 * Math.PI / 180; s += '<line x1="' + r(Math.cos(a) * 44) + '" y1="' + r(Math.sin(a) * 44) + '" x2="' + r(Math.cos(a) * 116) + '" y2="' + r(Math.sin(a) * 116) + '"/>'; }
    }
    s += '<circle r="44"/><circle r="30"/><circle r="11"/>';
    for (i = 0; i < 6; i++) { var b = (i * 60 + 30) * Math.PI / 180; s += '<circle class="plan-vis" cx="' + r(Math.cos(b) * 22) + '" cy="' + r(Math.sin(b) * 22) + '" r="2.6"/>'; }
    var logo = T.assets && T.assets.logo;
    if (logo) {
      s += '<g id="' + id + '"><image href="' + esc(logo) + '" x="-38" y="-205.5" width="76" height="19.7" class="plan-logo"/></g>';
      s += '<path class="plan-fin" d="M-6 196h12M0 192v8"/>';   // 6 o'clock mark (the second engraving sits there, upside down on the real rim)
    }
    return s + '</g></svg>';
  }
  function svgPlan(corps) { return '<svg class="plan" viewBox="-230 -230 460 460" aria-hidden="true" focusable="false"><path class="plan-axe" d="M-228 0H228M0 -228V228"/>' + corps + '</svg>'; }
  function planDisque() {
    var s = '', i, pts = [];
    for (i = 0; i <= 288; i++) { var a = i / 288 * 360; pts.push(pol(200 + 5 * Math.cos(12 * a * Math.PI / 180), a)); }
    s += '<path d="M' + pts.join('L') + 'Z"/><circle r="152" class="plan-fin"/>';
    for (i = 0; i < 24; i++) { var p0 = pol(184, i * 15).split(' '); s += '<circle class="plan-fin" cx="' + p0[0] + '" cy="' + p0[1] + '" r="4"/>'; }
    for (i = 0; i < 24; i++) { var p = pol(166, i * 15 + 7.5).split(' '); s += '<circle class="plan-fin" cx="' + p[0] + '" cy="' + p[1] + '" r="4"/>'; }
    s += '<g class="plan-vous"><circle r="138"/><circle r="46"/>';
    for (i = 0; i < 6; i++) { var b = i * 60 + 30; s += '<path d="M' + pol(46, b - 9) + 'L' + pol(138, b - 5) + 'M' + pol(46, b + 9) + 'L' + pol(138, b + 5) + '"/>'; }
    s += '</g>';
    for (i = 0; i < 10; i++) { var q = pol(145, i * 36).split(' '); s += '<circle cx="' + q[0] + '" cy="' + q[1] + '" r="3.5"/>'; }
    s += '<circle r="30"/>';
    for (i = 0; i < 6; i++) { var c = pol(38, i * 60).split(' '); s += '<circle cx="' + c[0] + '" cy="' + c[1] + '" r="3.2"/>'; }
    return svgPlan(s);
  }
  function planCouronne() {
    var s = '', i, N = 48, st = 360 / N, pts = [];
    for (i = 0; i < N; i++) { var a = i * st; pts.push(pol(186, a - .36 * st), pol(204, a - .14 * st), pol(204, a + .14 * st), pol(186, a + .36 * st)); }
    s += '<g class="plan-vous"><path d="M' + pts.join('L') + 'Z"/>';
    for (i = 0; i < 6; i++) {
      var b = i * 60;
      s += '<path d="M' + pol(104, b - 20) + 'L' + pol(154, b - 23) + 'A154 154 0 0 1 ' + pol(154, b + 23) + 'L' + pol(104, b + 20) + 'A104 104 0 0 0 ' + pol(104, b - 20) + 'Z"/>';
    }
    s += '<circle r="52"/></g><circle r="172" class="plan-fin"/><circle r="92" class="plan-fin"/>';
    for (i = 0; i < 6; i++) { var c = pol(72, i * 60 + 30).split(' '); s += '<circle cx="' + c[0] + '" cy="' + c[1] + '" r="6"/>'; }
    return svgPlan(s);
  }
  function planPatte() {
    var s = '<g class="plan-vous"><path d="M-170 -24C-170 -86 -70 -150 50 -150L148 -124C188 -112 196 -62 176 -26L122 82C100 124 34 144 -44 122L-142 74C-172 56 -170 22 -170 -24Z"/>';
    s += '<path d="M-60 -70L60 -96C84 -100 96 -84 88 -62L52 32C44 52 24 58 6 52L-70 26C-92 18 -96 -6 -86 -30Z" class="plan-fin"/></g>';
    [[-116, -18, 17], [-68, 84, 17], [134, -86, 13], [148, 6, 13]].forEach(function (h) {
      s += '<circle cx="' + h[0] + '" cy="' + h[1] + '" r="' + h[2] + '"/><circle cx="' + h[0] + '" cy="' + h[1] + '" r="' + (h[2] + 9) + '" class="plan-fin"/>';
    });
    s += '<path class="plan-axe" d="M134 -86L148 6M-116 -18L-68 84"/>';
    return svgPlan(s);
  }
  // captions of the hairline drawings (translated: snippets/strings-catalogue → EXODIA_THEME.stringsCatalogue)
  function strCat(k, d) { var sc = T.stringsCatalogue; return (sc && sc[k]) || d; }
  var REPLIS_CAT = {
    paire:    function () { return [[['cp-a', plan({ disque: true })], ['cp-b', plan()]], strCat('plan_paire', 'PLAN — LA PAIRE, AV + AR'), '']; },
    pack:     function () { return [[['cp-pack', plan({ disque: true })], ['cp-m1', planCouronne()], ['cp-m2', planPatte()]], strCat('plan_pack', 'PLAN — PACK COMPLET'), '']; },
    avant:    function () { return [[['cp-solo', plan({ disque: true })]], strCat('plan_avant', 'PLAN — AVANT, CÔTÉ DISQUE'), 'AV']; },
    arriere:  function () { return [[['cp-solo', plan()]], strCat('plan_arriere', 'PLAN — ARRIÈRE, CÔTÉ COURONNE'), 'AR']; },
    disque:   function () { return [[['cp-solo', planDisque()]], strCat('plan_disque', 'PLAN — DISQUE Ø 320 MM'), '320']; },
    couronne: function () { return [[['cp-solo', planCouronne()]], strCat('plan_couronne', 'PLAN — COURONNE'), 'AR']; },
    patte:    function () { return [[['cp-solo', planPatte()]], strCat('plan_patte', 'PLAN — PATTE DE DÉPORT'), 'AV']; },
    pneus:    function () { return [[['cp-a', plan()], ['cp-b', plan()]], strCat('plan_pneus', 'PLAN — LA PAIRE'), '']; },
    gravure:  function () { return [[['cp-solo', plan()]], strCat('plan_gravure', 'PLAN — GRAVURE 12 H / 6 H'), '']; }
  };
  // a card without a photo and without a rendered still: the hairline drawing of that reference
  function tuileRepli(el) {
    if (el.hasAttribute('data-rempli')) return;
    el.setAttribute('data-rempli', '');
    var r = (REPLIS_CAT[el.getAttribute('data-cat-repli')] || REPLIS_CAT.avant)();
    el.classList.remove('a-image'); el.classList.add('a-repli');
    el.innerHTML = r[0].map(function (c) { return '<span class="cp ' + c[0] + '">' + c[1] + '</span>'; }).join('') +
      (r[2] ? '<span class="cat-grand" aria-hidden="true">' + r[2] + '</span>' : '') +
      '<span class="repli-legende t-mono-s" aria-hidden="true">' + r[1] + '</span>';
  }
  function remplirCatalogue(dans) {
    $$('[data-cat-repli]', dans).forEach(function (el) {
      var im = $('img', el);
      if (!im) { tuileRepli(el); return; }
      // a missing still (asset not uploaded yet) falls back to the drawing instead of a broken image
      var ko = function () { tuileRepli(el); };
      if (im.complete && im.naturalWidth === 0 && im.currentSrc) ko();
      else im.addEventListener('error', ko, { once: true });
    });
  }

  /* ================================================================ finish swatches (« ÉGALEMENT ») */
  var TEINTES = {
    noir: ['Noir', '#141418', 'noir'], rouge: ['Rouge', '#c8121d', 'anod'], orange: ['Orange', '#ee6511', 'anod'], bleu: ['Bleu', '#1636cf', 'anod'],
    vert: ['Vert', '#1eb23a', 'anod'], violet: ['Violet', '#8b1fd6', 'anod']
  };
  var OFFRE = {
    disc: ['violet', 'bleu', 'orange', 'rouge', 'vert', 'noir'],
    sprocket: ['rouge', 'bleu', 'violet', 'noir', 'vert', 'orange'],
    bracket: ['violet', 'orange', 'vert', 'rouge', 'noir', 'bleu']
  };
  function fondLocal(slug) {
    var t = TEINTES[slug]; if (!t) return '#333';
    if (t[2] === 'noir') return 'linear-gradient(118deg, transparent 0 33%, rgba(255,255,255,.2) 39%, transparent 46%), linear-gradient(160deg, #3b3b41 0%, ' + t[1] + ' 42%, #050507 100%)';
    return 'linear-gradient(118deg, transparent 0 33%, rgba(255,255,255,.26) 40%, transparent 48%), linear-gradient(160deg, color-mix(in oklab, ' + t[1] + ' 78%, #fff) 0%, ' + t[1] + ' 42%, color-mix(in oklab, ' + t[1] + ' 78%, #000) 100%)';
  }
  var NOMBRES = ['Aucune', 'Une', 'Deux', 'Trois', 'Quatre', 'Cinq', 'Six', 'Sept', 'Huit', 'Neuf', 'Dix', 'Onze', 'Douze', 'Treize', 'Quatorze'];
  function finitions(ligne) {
    var S = window.EXODIA_SITE, l = null;
    if (S && typeof S.finitions === 'function') { try { l = S.finitions(ligne); } catch (e) { l = null; } }
    if (l && l.length) return l.map(function (f) { return { nom: f.nom, fond: f.fond || f.hex }; });
    return (OFFRE[ligne] || []).map(function (s) { return { nom: TEINTES[s][0], fond: fondLocal(s) }; });
  }
  function remplirNuanciers() {
    $$('[data-finitions]').forEach(function (el) {
      el.innerHTML = finitions(el.getAttribute('data-finitions')).map(function (f) { return '<i style="background:' + esc(f.fond) + '" title="' + esc(f.nom) + '"></i>'; }).join('');
    });
    $$('[data-nb-finitions]').forEach(function (el) {
      var n = finitions(el.getAttribute('data-nb-finitions')).length;
      if (!n) return;
      el.textContent = el.hasAttribute('data-chiffre') ? String(n) : (NOMBRES[n] || String(n));
    });
  }

  /* ================================================================ « LE CATALOGUE » rail */
  function railCatalogue() {
    var piste = $('#cat-piste'), prec = $('#cat-prec'), suiv = $('#cat-suiv'); if (!piste || !prec || !suiv) return;
    if (piste.hasAttribute('data-rail-pret')) return;
    piste.setAttribute('data-rail-pret', '');
    var compte = $('#cat-compte'), curseur = $('#cat-regle-curseur');
    var cartes = $$('.cat-carte', piste), n = cartes.length, raf = 0;
    function deux(v) { return ('0' + v).slice(-2); }
    function pas() { return cartes.length < 2 ? piste.clientWidth : cartes[1].getBoundingClientRect().left - cartes[0].getBoundingClientRect().left; }
    function bornes() { return Math.max(0, piste.scrollWidth - piste.clientWidth); }
    function maj() {
      raf = 0;
      var max = bornes(), x = piste.scrollLeft, r = piste.getBoundingClientRect(), prem = -1, der = -1;
      prec.setAttribute('aria-disabled', String(x <= 2));
      suiv.setAttribute('aria-disabled', String(x >= max - 2));
      cartes.forEach(function (c, i) {
        var b = c.getBoundingClientRect();
        if (b.left >= r.left - 4 && b.right <= r.right + 4) { if (prem < 0) prem = i; der = i; }
      });
      if (prem < 0) { prem = der = Math.min(n - 1, Math.max(0, Math.round(x / Math.max(1, pas())))); }
      if (compte) compte.textContent = deux(prem + 1) + (der > prem ? '–' + deux(der + 1) : '') + ' / ' + deux(n);
      if (curseur) {
        var frac = piste.scrollWidth > 0 ? Math.min(1, piste.clientWidth / piste.scrollWidth) : 1;
        curseur.style.width = (frac * 100).toFixed(2) + '%';
        curseur.style.transform = 'translateX(' + (max > 0 ? x / max * (1 / frac - 1) * 100 : 0).toFixed(2) + '%)';
      }
    }
    function planifier() { if (!raf) raf = requestAnimationFrame(maj); }
    function defiler(sens, tout) {
      var p = pas(), k = Math.max(1, Math.floor((piste.clientWidth + 8) / Math.max(1, p)));
      var cible = tout ? (sens < 0 ? 0 : bornes()) : piste.scrollLeft + sens * k * p;
      cible = Math.max(0, Math.min(bornes(), cible));
      var depart = piste.scrollLeft;
      try { piste.scrollTo({ left: cible, behavior: reduit() ? 'auto' : 'smooth' }); } catch (e) { piste.scrollLeft = cible; }
      setTimeout(function () { if (Math.abs(piste.scrollLeft - depart) < 2 && Math.abs(cible - depart) >= 2) piste.scrollLeft = cible; planifier(); }, reduit() ? 0 : 500);
    }
    prec.addEventListener('click', function () { if (prec.getAttribute('aria-disabled') !== 'true') defiler(-1); });
    suiv.addEventListener('click', function () { if (suiv.getAttribute('aria-disabled') !== 'true') defiler(1); });
    piste.addEventListener('keydown', function (e) {
      if (e.target !== piste || e.altKey || e.ctrlKey || e.metaKey) return;
      var k = { ArrowRight: [1], ArrowLeft: [-1], Home: [-1, true], End: [1, true] }[e.key];
      if (!k) return;
      e.preventDefault(); defiler(k[0], k[1]);
    });
    piste.addEventListener('focusin', function (e) {
      var c = e.target.closest && e.target.closest('.cat-carte'); if (!c) return;
      var r = piste.getBoundingClientRect(), b = c.getBoundingClientRect(), cs = getComputedStyle(piste);
      var gauche = r.left + (parseFloat(cs.paddingLeft) || 0), droite = r.right - (parseFloat(cs.paddingRight) || 0);
      if (b.left >= gauche - 1 && b.right <= droite + 1) return;
      var cible = Math.max(0, Math.min(bornes(), piste.scrollLeft + b.left - gauche));
      try { piste.scrollTo({ left: cible, behavior: reduit() ? 'auto' : 'smooth' }); } catch (er) { piste.scrollLeft = cible; }
      var depart = piste.scrollLeft;
      setTimeout(function () { if (Math.abs(piste.scrollLeft - depart) < 2 && Math.abs(cible - depart) >= 2) piste.scrollLeft = cible; planifier(); }, reduit() ? 0 : 500);
    });
    piste.addEventListener('scroll', planifier, { passive: true });
    window.addEventListener('resize', planifier);
    try { document.fonts.ready.then(planifier); } catch (e) {}
    maj();
  }

  /* ================================================================ configurator state → this page */
  function majCompat(nom) {
    var el = $('#compat-marque'); if (!el || !nom) return;
    if (el.textContent !== nom) el.textContent = nom;
    $$('.compat-nuage a').forEach(function (a) { a.classList.toggle('sur-fiche', normal(a.getAttribute('data-marque')) === normal(nom)); });
  }
  var bande = $('#bande'), devPerso = $('#dev-perso');
  function ajusterPerso() {
    if (!devPerso || !bande) return;
    devPerso.style.fontSize = '';
    var lg = $('.logo-grave', bande), w = devPerso.scrollWidth;
    if (!lg) return;
    var dispo = bande.clientWidth / 2 - lg.offsetWidth - 20;
    if (w > dispo && dispo > 0) devPerso.style.fontSize = (parseFloat(getComputedStyle(devPerso).fontSize) * dispo / w).toFixed(2) + 'px';
  }
  document.addEventListener('exodia:etat', function (e) {
    var d = e.detail || {};
    if (d.marque) majCompat(String(d.marque));
    if (bande && typeof d.rimHex === 'string' && /^#[0-9a-f]{6}$/i.test(d.rimHex)) bande.style.setProperty('--c', d.rimHex);
    if (devPerso && typeof d.gravure === 'string' && devPerso.textContent !== d.gravure) { devPerso.textContent = d.gravure; ajusterPerso(); }
  });
  function etatInitial() {
    var S = window.EXODIA_SITE, d = null;
    if (S && typeof S.etat === 'function') { try { d = S.etat(); } catch (e) { d = null; } }
    if (d) emettre('exodia:etat', d);
  }

  /* ================================================================ reveals: the engraving band */
  function bandeLaser() {
    if (!bande || !window.IntersectionObserver || reduit() || bande.hasAttribute('data-bande-pret')) return;
    bande.setAttribute('data-bande-pret', '');
    bande.classList.add('dev-attente');
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(bande);
        var logos = $('.dev-logos', bande), l = $('#dev-laser'), W2 = bande.offsetWidth;
        bande.classList.remove('dev-attente');
        if (!logos.animate) return;
        logos.animate([{ clipPath: 'inset(0 100% 0 0)' }, { clipPath: 'inset(0 0% 0 0)' }], { duration: 1600, easing: 'linear' });
        if (l) l.animate([{ transform: 'translateX(0)', opacity: 1 }, { transform: 'translateX(' + (W2 - 1) + 'px)', opacity: 1, offset: .96 }, { transform: 'translateX(' + (W2 - 1) + 'px)', opacity: 0 }], { duration: 1600, easing: 'linear' });
      });
    }, { threshold: .4 });
    io.observe(bande);
  }

  /* ================================================================ atelier lamp pool (desktop, fine pointer) */
  function brancherAtelier() {
    var atelier = $('#atelier'); if (!atelier || atelier.hasAttribute('data-lampe-pret')) return;
    atelier.setAttribute('data-lampe-pret', '');
    atelier.addEventListener('pointermove', function (e) {
      if (!mqFin.matches || !mqDesk.matches) return;
      var r = atelier.getBoundingClientRect();
      atelier.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      atelier.style.setProperty('--my', (e.clientY - r.top) + 'px');
      atelier.classList.add('eclaire');
    });
    atelier.addEventListener('pointerleave', function () { atelier.classList.remove('eclaire'); });
  }
  brancherAtelier();

  /* ================================================================ dialogs: « NOTRE HISTOIRE » */
  var retourHistoire = null;
  function brancherHistoire() {
    var d = $('#histoire-d'), fermer = $('#histoire-fermer'); if (!d || d.hasAttribute('data-histoire-pret')) return;
    d.setAttribute('data-histoire-pret', '');
    if (fermer) fermer.addEventListener('click', function () { try { d.close(); } catch (e) { d.removeAttribute('open'); } });
    d.addEventListener('click', function (e) { if (e.target === d) { try { d.close(); } catch (er) {} } });
    d.addEventListener('close', function () { if (retourHistoire) { try { retourHistoire.focus({ preventScroll: true }); } catch (e) {} } retourHistoire = null; });
  }
  brancherHistoire();
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-histoire]'); if (!b) return;
    var d = $('#histoire-d'), fermer = $('#histoire-fermer'); if (!d) return;
    brancherHistoire();
    e.preventDefault(); fermerListe(); retourHistoire = b;
    try { d.showModal(); } catch (er) { d.setAttribute('open', ''); }
    if (fermer) fermer.focus();
  });

  /* ================================================================ FAQ: + / −, footer links to one question */
  function brancherFaq(dans) {
    $$('.questions details', dans).forEach(function (d) {
      if (d.hasAttribute('data-faq-pret')) return;
      d.setAttribute('data-faq-pret', '');
      d.addEventListener('toggle', function () { var pm = $('.pm', d); if (pm) pm.textContent = d.open ? '−' : '+'; });
    });
  }
  brancherFaq(document);
  function ouvrirQuestion(id, defiler) {
    var d = document.getElementById(id); if (!d || d.tagName !== 'DETAILS') return false;
    d.open = true;
    if (defiler !== false) {
      var h = $('#ascenseur'), y = d.getBoundingClientRect().top + window.pageYOffset - (h ? h.offsetHeight : 48) - 24;
      defilerFenetre(y);
    }
    setTimeout(function () { try { $('summary', d).focus({ preventScroll: true }); } catch (er) {} }, 60);
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-question]'); if (!a) return;
    if (ouvrirQuestion(a.getAttribute('data-question'))) e.preventDefault();
  });

  /* ================================================================ footer: switch, lights off */
  function brancherInterrupteur() {
    var inter = $('#inter'), ext = $('#extinction'), page = $('#page'), evitement = $('#evitement'), eteint = false;
    if (!inter || !ext || inter.hasAttribute('data-inter-pret')) return;
    inter.setAttribute('data-inter-pret', '');
    function eteindre() {
      eteint = true;
      inter.setAttribute('aria-pressed', 'true');
      // the screen is rendered by the footer section (inside #page): out of the page before the page goes inert
      if (ext.parentNode !== document.body) document.body.appendChild(ext);
      ext.hidden = false; if (page) page.inert = true; if (evitement) evitement.inert = true;
      requestAnimationFrame(function () { requestAnimationFrame(function () { ext.classList.add('on'); }); });
      ext.focus();
    }
    function rallumer() {
      if (!eteint) return;
      eteint = false;
      ext.classList.remove('on'); if (page) page.inert = false; if (evitement) evitement.inert = false;
      setTimeout(function () { ext.hidden = true; inter.setAttribute('aria-pressed', 'false'); inter.focus(); }, reduit() ? 150 : 600);
    }
    inter.addEventListener('click', eteindre);
    ext.addEventListener('click', rallumer);
    document.addEventListener('keydown', function (e) {
      if (!eteint) return;
      if (e.key === 'Escape') { e.preventDefault(); rallumer(); }
      else if (e.key === 'Tab') { e.preventDefault(); ext.focus(); }
    });
  }
  brancherInterrupteur();

  /* ================================================================ skip link: straight to the configurator when there is one */
  (function () {
    var ev = $('#evitement'); if (!ev) return;
    if (document.getElementById('scene')) {
      ev.setAttribute('href', '#scene');
      if (ev.getAttribute('data-texte-configurateur')) ev.textContent = ev.getAttribute('data-texte-configurateur');
    }
    ev.addEventListener('click', function (e) {
      var id = (ev.getAttribute('href') || '').slice(1), el = document.getElementById(id); if (!el) return;
      e.preventDefault();
      window.scrollTo(0, el.getBoundingClientRect().top + window.pageYOffset);
      setTimeout(function () { var f = id === 'scene' ? focusDe('scene') : el; try { if (f) f.focus({ preventScroll: true }); } catch (er) {} }, 50);
    });
  })();

  /* ================================================================ boot */
  function demarrer() {
    numeroterFantomes();
    preparerLasers(document);
    remplirCatalogue(document);
    remplirNuanciers();
    railCatalogue();
    bandeLaser();
    var sp = $('#salle-plan'); if (sp) sp.innerHTML = planAxes() + plan({ disque: true });
    if (window.IntersectionObserver) {
      var entreeEl = $('#entree');
      if (entreeEl) new IntersectionObserver(function (ents) { entreeEl.classList.toggle('hors', !ents[ents.length - 1].isIntersecting); }).observe(entreeEl);
    }
    // the hash: a section (#catalogue), a FAQ answer (#q-delai), the newsletter form after posting, or a shared
    // configuration code (handled by the configurator) — the page scrolls there once the fonts are in place
    var hash = ''; try { hash = decodeURIComponent(String(location.hash || '').slice(1)); } catch (e) { hash = ''; }
    var cibleHash = /^[A-Za-z][\w-]{0,60}$/.test(hash) ? document.getElementById(hash) : null;
    var formulaire = /[?&](customer_posted|contact_posted)=/.test(location.search) || $('.lettre-err, .lettre-ok');
    var viserId = cibleHash && hash !== 'entree' ? hash : (formulaire && $('#newsletter') ? 'newsletter' : null);
    if (viserId) {
      var viser = function () {
        if (cibleHash && cibleHash.tagName === 'DETAILS') { ouvrirQuestion(viserId, false); }
        var el = document.getElementById(viserId); if (el) window.scrollTo(0, el.getBoundingClientRect().top + window.pageYOffset - (cibleHash && cibleHash.tagName === 'DETAILS' ? 72 : 0));
      };
      requestAnimationFrame(viser);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(viser);
    }
    var ok = $('#lettre-ok'); if (ok) setTimeout(function () { try { ok.focus({ preventScroll: true }); } catch (e) {} }, 80);
    // after the other deferred scripts (the configurator) have run: they listen to these
    apresScripts(function () {
      emettre('exodia:ouvert', { instant: true });
      remplirNuanciers();
      etatInitial();
    });
    window.addEventListener('load', function () { remplirNuanciers(); etatInitial(); });
  }

  function apresScripts(fn) {
    var fait = false;
    function une() { if (fait) return; fait = true; fn(); }
    if (document.readyState === 'complete') { setTimeout(une, 0); return; }
    document.addEventListener('DOMContentLoaded', function () { setTimeout(une, 0); });
    window.addEventListener('load', une);
  }

  /* ================================================================ theme editor (« Personnaliser »)
     A section is re-rendered on every setting change and its scripts do not run again (shopify.dev › integrate
     sections with the theme editor): re-run what this script builds in it. The configurator handles its own. */
  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target; if (!sec) return;
    bande = $('#bande'); devPerso = $('#dev-perso');
    numeroterFantomes();
    preparerLasers(sec);
    remplirCatalogue(sec);
    remplirNuanciers();
    railCatalogue();
    bandeLaser();
    brancherFaq(sec);
    brancherAtelier();
    brancherHistoire();
    brancherInterrupteur();
    var sp = $('#salle-plan', sec); if (sp) sp.innerHTML = planAxes() + plan({ disque: true });
    etatInitial();
    // in the editor the section shows at once (no laser wait)
    $$('.lz-attente', sec).forEach(function (h) { h.classList.remove('lz-attente'); });
  });

  T.formatMoney = formatMoney;
  T.toast = function (t) { montrerToast(String(t)); };
  T.annoncer = annoncer;
  T.aller = function (id) { return aller(id); };
  T.ouvrir = ouvrir;
  T.estOuvert = estOuvert;
  T.majPanier = majPanier;
  T.rafraichirPanier = rafraichirPanier;
  T.plan = plan;
  T.rafraichir = function () { numeroterFantomes(); preparerLasers(document); remplirCatalogue(document); remplirNuanciers(); };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer); else demarrer();
})();
